export default {
  props: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  methods: {
    goBack() {
      console.error("mixins go back!!!!!!!!!!!");
    }
  },
  mounted() {

  },
  activated() {
    this.$eventHub.$once('AuthGoBack', () => {
      this.goBack();
    });
  },
  deactivated() {
    this.$eventHub.$off('AuthGoBack');
  }
}
